import React from "react";
import Roll from "react-reveal/Roll";
import "./Styles/portfolio.css";
import Fade from "react-reveal/Fade";
import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel
} from "react-accessible-accordion";
import "react-accessible-accordion/dist/fancy-example.css";

function Portfolio() {
  return (
    <>
      <section id="expertise">
        <div className="container">
          <header className="mb-5 pb-4" style={{ textAlign: "center" }}>
            <p
              className="font-weight-bold text-primary text-uppercase letter-spacing-3"
              style={{ fontSize: "2rem" }}
            >
              Portfolio
            </p>
            <h3 className="text-none lined">
              Check what I've been doing lately
            </h3>
          </header>

          <span className="section">
            <span className="slanted">Adebayo Portfolio</span>
          </span>

          <div class="row">
            <div class="col-sm-8">
              <p>
                This very website you're now watching. I wanted something fast
                and with a Single Page Application (SPA). It was built with the
                segmentation of react's components. The application seems
                responsive on Mobile screen with modern animation effects.
                <p style={{ marginTop: "15px" }}>
                  The application was containerized for production using Docker
                </p>
                <span>
                  <p style={{ marginTop: "20px" }}>
                    {" "}
                    <strong>Stack Use </strong>
                  </p>
                  <li>JavaScript ES6+</li>
                  <li>JSX</li>
                  <li>CSS</li>
                  <li>React Js</li>
                  <li>Bootscrap 4</li>
                </span>
              </p>

              <span>
                <a type="button" className="btn btn info" href="">
                  <i className="fas fa-link"></i> Visit
                </a>
              </span>
            </div>

            <div
              class="col-sm-4"
              style={{
                margin: "3px -2px 1rem"
              }}
            >
              <Roll left>
                <img
                  src="https://res.cloudinary.com/developerbiodun/image/upload/v1581328779/developerB_yqhllk.png"
                  width="100%"
                  className="img-responsive"
                  style={{
                    filter: "drop-shadow(4px 25px 15px rgba(0, 0, 0, 0.4))"
                  }}
                />
              </Roll>
            </div>
          </div>

          <hr />

          <span className="section">
            <span className="slanted">eDataMap</span>
          </span>

          <div class="row">
            <div class="col-sm-4">
              <Roll left>
                <img
                  src="https://res.cloudinary.com/developerbiodun/image/upload/v1581329441/edatamap_csemri.png"
                  width="100%"
                  style={{
                    filter: "drop-shadow(4px 25px 15px rgba(0, 0, 0, 0.4))"
                  }}
                />
              </Roll>
            </div>

            <hr />
            <div
              class="col-sm-8"
              style={{
                margin: "3px -2px 1rem"
              }}
            >
              <p>
                This application was built in need of Geospatial data gathering
                tool.
                <p style={{ marginTop: "15px" }}>
                  As a convention, most objects on the earth's surface are
                  Geo-referenced with Latitude and Longitude coordinates. So
                  this app stores the real-time coordinate data and plots the
                  object on Google Maps for better visibility of the
                  information. The application can be used by Telecommunication
                  providers or any infrastructure-based firm with
                  infrastructures distributed on the earth-surface
                </p>
                <p>
                  {" "}
                  It helps to track where the nodes/object and also tooling of
                  Geography Information Systems (GIS) Data verification
                </p>
                <span>
                  <p style={{ marginTop: "20px" }}>
                    {" "}
                    <strong>Stack Use </strong>
                  </p>

                  <li>React Js</li>
                  <li>JavaScript ES6+</li>
                  <li>JSX</li>
                  <li>CSS</li>
                  <li>Apollo Client</li>
                  <li>Bootscrap 4</li>

                  <p style={{ marginTop: "10px" }}>
                    {" "}
                    <strong> Back-End Architecture (APIs) </strong>
                  </p>
                  <li>NodeJs</li>
                  <li>ExpressJs</li>
                  <li>MongoDB</li>
                  <li>GraphQL</li>
                  <li>Apollo Server</li>
                </span>
                <span>
                  <Accordion
                    allowZeroExpanded="true"
                    style={{ marginTop: "20px" }}
                  >
                    <AccordionItem>
                      <AccordionItemHeading>
                        <AccordionItemButton>
                          Project Challenges ?{" "}
                        </AccordionItemButton>
                      </AccordionItemHeading>
                      <AccordionItemPanel>
                        <p>
                          Here are the challenges as follows:
                          <li>Designing the UI and styling</li>
                          <li>Understanding JavaScript and its architecture</li>
                          <li>Understanding the creation of APIs</li>
                        </p>
                      </AccordionItemPanel>
                    </AccordionItem>
                  </Accordion>
                </span>
              </p>
              <span>
                <a
                  target="blank"
                  className="btn btn info"
                  href="https://edatamap.herokuapp.com/login"
                >
                  <i className="fas fa-link"></i> Visit
                </a>
              </span>
            </div>
          </div>

          <hr />

          <span className="section">
            <span className="slanted">efault-Map</span>
          </span>

          <div class="row">
            <div class="col-sm-8">
              <p>
                A fault detection tool to point-out the point of failure on a
                earth surafce.
                <p style={{ marginTop: "15px" }}>
                  {" "}
                  To achieve this application seems daunting due to algorithm
                  for calculating the shortest distances path and the use of
                  Geodesic Mathematical formation for computation
                </p>
                <span>
                  <p style={{ marginTop: "20px" }}>
                    <strong>Stack Use </strong>
                  </p>
                  <li>HTML 5 / CSS 3</li>
                  <li>Jquery</li>
                  <li>Vanilla JavaScript</li>
                  <li>Google Maps APIs</li>
                  <li>Bootscrap 4</li>
                  <li>Map Styling (Uber/ Google Maps)</li>
                </span>
              </p>
              <span>
                <a
                  className="btn btn info"
                  target="blank"
                  href="https://production-app.github.io/efault-map/"
                >
                  <i className="fas fa-link"></i> Visit
                </a>
              </span>
              <span>
                <Accordion
                  allowZeroExpanded="true"
                  style={{ marginTop: "20px" }}
                >
                  <AccordionItem>
                    <AccordionItemHeading>
                      <AccordionItemButton>
                        Project Challenges ?{" "}
                      </AccordionItemButton>
                    </AccordionItemHeading>
                    <AccordionItemPanel>
                      <p>
                        Here are the challenges as follows:
                        <li>Understanding Mathematical Algorithm</li>
                        <li>Understanding Google Maps APIs</li>
                        <li>
                          Researching the Geographical Information Systems (GIS)
                          concepts
                        </li>
                      </p>
                    </AccordionItemPanel>
                  </AccordionItem>
                </Accordion>
              </span>
            </div>

            <div
              class="col-sm-4"
              style={{
                margin: "3px -2px 1rem"
              }}
            >
              <Roll left>
                <img
                  src="https://res.cloudinary.com/developerbiodun/image/upload/v1581329444/efaultMap_sle8yj.png"
                  width="100%"
                  style={{
                    filter: "drop-shadow(4px 25px 15px rgba(0, 0, 0, 0.4))"
                  }}
                />
              </Roll>
            </div>
          </div>

          <hr />

          <span className="section">
            <span className="slanted">eFiberDocs</span>
          </span>

          <div class="row">
            <div class="col-sm-4">
              <Roll left>
                <img
                  src="https://res.cloudinary.com/developerbiodun/image/upload/v1581329440/efiberDoc_aztjlq.png"
                  width="100%"
                  style={{
                    filter: "drop-shadow(4px 25px 15px rgba(0, 0, 0, 0.4))"
                  }}
                />
              </Roll>
            </div>

            <div
              class="col-sm-8"
              style={{
                margin: "3px -2px 1rem"
              }}
            >
              <p>
                A full dashboard designs to enhaced the user's experience.
                <p style={{ marginTop: "10px" }}>
                  {" "}
                  This application helps in the documentation of fibre optics
                  routes (point-to-point) and all of its properties like the
                  length of cable, Locations, etc. The application leverage on
                  Google Sheets and Google Firebase storage for data storage.
                </p>
                <p style={{ marginTop: "10px" }}>
                  The application leverage on Google Sheets and Google Firebase
                  storage for data storage.
                </p>
                <p style={{ marginTop: "10px" }}>
                  However, all of the information can be viewed on a real-time
                  Google Sheets for better user's collaboration and analysis
                </p>
                <span>
                  <p style={{ marginTop: "10px" }}>
                    <strong>Stack Use</strong>
                  </p>
                  <li>React Js (Styled Components)</li>
                  <li>Google Materelize CSS</li>
                  <li>Redux</li>

                  <p style={{ marginTop: "10px" }}>
                    {" "}
                    <strong> Back-End Architecture (SERVERLESS)</strong>
                  </p>
                  <li>Google Cloud Functions</li>
                  <li>Google AppScripts</li>
                  <li>Google Sheets</li>
                </span>
              </p>
              <span>
                <a
                  target="blank"
                  className="btn btn info"
                  href="https://efiberdocs.firebaseapp.com/"
                >
                  <i className="fas fa-link"></i> Visit
                </a>
              </span>
            </div>
          </div>

          <hr />

          <span className="section">
            <span className="slanted">eLabel</span>
          </span>

          <div class="row">
            <div class="col-sm-4">
              <Roll left>
                <img
                  src="https://res.cloudinary.com/developerbiodun/image/upload/v1581329443/elabel_vhaacl.png"
                  width="100%"
                  style={{
                    filter: "drop-shadow(4px 25px 15px rgba(0, 0, 0, 0.4))"
                  }}
                />
                <br />
                <br />

                <img
                  src="img/tb.png"
                  style={{
                    position: "relative",
                    top: "-120px",
                    left: "-32px",
                    width: "128px"
                  }}
                />
              </Roll>
            </div>

            <div
              class="col-sm-8"
              style={{
                margin: "3px -2px 1rem"
              }}
            >
              <p>
                eLabel app as the suggests, is used to obscured labels/Object
                name from other third parties.{" "}
              </p>

              <p style={{ marginTop: "10px" }}>
                {" "}
                It's decrypts the data into meaningful information. Leveraging
                the power of Cryptography
              </p>

              <p style={{ marginTop: "10px" }}>
                {" "}
                This can be integrated into QR-CODE and remotely access the
                information at any-time
              </p>
              <span>
                <p style={{ marginTop: "10px" }}>
                  <strong>Stack Use</strong>
                </p>
                <li>HTML/CSS</li>
                <li>Vanilla JavaScript</li>

                <p style={{ marginTop: "10px" }}>
                  {" "}
                  <strong> Back-End Architecture</strong>
                </p>
                <li>Python (Django v2.2.)</li>
                <li>PyCrypto </li>
                <li>SQLite DB</li>
                <li>Jinja Templating Engine</li>
              </span>
              <br />
              <span>
                <a
                  target="blank"
                  className="btn btn info"
                  href="http://elabelapp.herokuapp.com/"
                >
                  <i className="fas fa-link"></i> Visit
                </a>
              </span>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Portfolio;
